export default __webpack_public_path__ + "static/media/fewclouds.17a62d37.jpg";